// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".czt-newsletter-button{display:block;border:2px solid #f5f5f5;padding:0.3125rem 0.625rem;height:3.75rem}.czt-newsletter-button--active{border-color:#178fcf;background-color:rgba(23,143,207,.1)}.czt-newsletter-button .czt-checkbox{pointer-events:none;padding:0;margin:0}.czt-newsletter-button .czt-checkbox .v-messages{display:none}", ""]);
// Exports
module.exports = exports;
